<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<div class="flex">
			<h1 v-if="!editMode">Create product</h1>
			<h1 v-if="editMode">Edit product: {{ parent_sku }}</h1>
			<div class="flex-grow text-right">
				<a target="_blank" :href="`${wp_url}/post.php?post=` + getId() + '&action=edit'"><button>Woocommerce</button></a>
        <button v-on:click="pushProductToWarehouse(getId())" class="margin-left">Push to warehouse</button>
      </div>
		</div>

		<Tabs :tabs="tabs" v-model="active_tab" class="margin-top large-margin-bottom" />

		<div v-show="active_tab == 'general'">
			<div class="margin-bottom">
				<div class="flex margin-top">
					<div class="label">
						<strong>Title</strong>
					</div>
					<div>
						<input style="width: 385px;" type="text" maxlength="255" v-model="title" />
					</div>
				</div>
				<div class="flex margin-top">
					<div class="label">
						<strong>Parent SKU</strong>
					</div>
					<div>
						<input :disabled="editMode" type="text" maxlength="40" v-model="parent_sku" />
					</div>
				</div>
				<div v-for="currency in currencies" :key="currency.id" class="price-wrapper">
					<div class="flex small-margin-top price">
						<div class="label">
							<strong>Price {{currency.iso4217_code}}</strong>
						</div>
						<div>
							<input type="number" v-model="price[currency.id]" v-on:change="updateSalesPrice(currency.id)"/>
						</div>
					</div>
					<div class="flex small-margin-top price sales-price">
						<div class="label">
							<strong>Sale price {{currency.iso4217_code}}</strong>
						</div>
						<div style="color: #6a6464; font-size: smaller;">
							<input type="text" class="percentage" v-model="price_percentage[currency.id]" v-on:change="updateSalesPercentage(currency.id)" /> % less &nbsp;
						</div>
						<div>
							<input type="number" v-model="sales_price[currency.id]"/>
						</div>
					</div>
				</div>
				<div class="flex small-margin-top">
					<div class="label">
						<strong>Category</strong>
					</div>
					<div>
						<select class="select" type="select" v-model="category">
							<option value="">&lt;&dash; Select &dash;&gt;</option>
							<option v-for="category in parentCategory" :value="category.id" v-text="category.name"></option>
						</select>
					</div>
				</div>
        <div class="flex small-margin-top" v-if="subCategories.length > 0">
          <div class="label">
            <strong>Subcategory</strong>
          </div>
          <div>
            <select class="select" type="select" v-model="subcategory">
              <option value="">&lt;&dash; Subcategory &dash;&gt;</option>
              <option v-for="category in subCategories" :value="category.id" v-text="category.name"></option>
            </select>
          </div>
        </div>
        <div class="flex small-margin-top" v-if="this.category !== undefined && this.id !== undefined">
          <div class="label">
            <strong>Attributes</strong>
          </div>
          <ProductAttributes
            :id="getId()"
            :category="this.category"
          />
        </div>
        <div class="flex small-margin-top">
          <div class="label">
            <strong>Pants length</strong>
          </div>
          <div>
            <select class="select" type="select" v-model="pantSize">
              <option value="">&lt;&dash; Select &dash;&gt;</option>
              <option v-for="pantSize in pantSizes" :value="pantSize" v-text="pantSize"></option>
            </select>
          </div>
        </div>
				<div class="flex small-margin-top">
					<div class="label">
						<strong>Tags</strong>
					</div>
					<div>
						<ProductTags v-on:tag-selected="tagSelected" :id="getId()" />
					</div>
				</div>
				<div class="flex small-margin-top">
					<div class="label">
						<strong>Brand</strong>
					</div>
					<div>
						<select class="select" type="select" v-model="brand">
							<option value="">&lt;&dash; Select &dash;&gt;</option>
							<option v-for="brand in brands" :value="brand.name" v-text="brand.name"></option>
						</select>
					</div>
				</div>
				<div class="flex small-margin-top">
					<div class="label">
						<strong>Color</strong>
					</div>
					<div>
						<select class="select" type="select" v-model="color">
							<option value="">&lt;&dash; Select &dash;&gt;</option>
							<option v-for="color in colors" :value="color.label" v-text="color.label"></option>
						</select>
						<i style="color: red; margin-left: 10px;" v-if="exceptions.color !== undefined" v-text="exceptions.color"></i>
					</div>
				</div>

        <!-- Print -->
				<div class="flex small-margin-top">
					<div class="label">
						<strong>Print</strong>
					</div>
					<div>
						<select class="select" type="select" v-model="print">
							<option value="">&lt;&dash; Select &dash;&gt;</option>
							<option v-for="print in prints" :value="print.label" v-text="print.label"></option>
						</select>
					</div>
				</div>

        <!-- Colorful (Product Option) -->
        <div class="flex small-margin-top">
          <div class="label">
            <strong>Colorful</strong>
          </div>
          <div>
            <select class="select" type="select" v-model="colorful_id">
              <option value="">&lt;&dash; Select &dash;&gt;</option>
              <option v-for="row in product_options" v-if="row.category === 'colorful'" :value="row.id" v-text="row.name"></option>
            </select>
          </div>
        </div>

        <!-- Patterns (Product Option) -->
        <div class="flex small-margin-top">
          <div class="label">
            <strong>Patterns</strong>
          </div>
          <div>
            <select class="select" type="select" v-model="patterns_id">
              <option value="">&lt;&dash; Select &dash;&gt;</option>
              <option v-for="row in product_options" v-if="row.category === 'patterns'" :value="row.id" v-text="row.name"></option>
            </select>
          </div>
        </div>

				<div class="flex small-margin-top">
					<div class="label">
						<strong>Materials</strong>
					</div>
					<div style="display: flex; flex-direction: column;">
						<div v-for="material in materials">
							<select class="select" type="select" v-model="material.material">
								<option value="">&lt;&dash; Select &dash;&gt;</option>
								<option v-for="materialName in materialList" :value="materialName"
										v-text="materialName.name"></option>
							</select>
							<input type="text" class="percentage" v-on:change="checkForPercentage(material)" v-model="material.percentage">%
							<button class="smaller delete-material" v-on:click="removeMaterial(material)">X</button>
						</div>
					</div>
				</div>
        <div class="flex" v-if="materials.length < 5">
          <div class="label"></div>
          <div>
            <button class="smaller" v-on:click="addMaterial()">+</button>
          </div>
        </div>
        <div class="flex small-margin-top">
          <div class="label">
            <strong>Style name</strong>
          </div>
          <div>
            <select class="select" type="select" v-model="style">
              <option value="">&lt;&dash; Select &dash;&gt;</option>
              <option v-for="style in styles" :value="style.name" v-text="style.name"></option>
            </select>
          </div>
        </div>
        <div class="flex margin-top">
          <div class="label">
            <strong>Description</strong>
          </div>
          <div>
            <textarea style="width: 385px;" v-model="description" />
          </div>
        </div>
        <div class="flex small-margin-top">
          <div class="label">
            <strong>Country of origin</strong>
          </div>
          <select class="select" type="select" v-model="country">
            <option value="">&lt;&dash; Select &dash;&gt;</option>
            <option v-for="country in countries" :value="country.id" v-text="country.name"></option>
          </select>
        </div>
        <div class="flex small-margin-top">
          <div class="label">
            <strong>Weight</strong>
          </div>
          <div>
            <input type="text" maxlength="20" v-model="weight" />
          </div>
        </div>
        <div class="flex small-margin-top">
          <div class="label">
            <strong>Tariff</strong>
          </div>
          <div>
            <input type="text" maxlength="20" v-model="tariff" />
          </div>
        </div>
			</div>
			<div class="margin-top padding-top border-top">
        <Loader v-if="softLoading" :soft="true" />
				<table v-if="hasVariants">
					<thead>
						<tr>
							<th width="5%" style="padding-right: 0">SKU</th>
							<th width="15%">Size</th>
							<th width="15%">EAN</th>
							<th width="15%">Quantity</th>
							<th width="15%">WP ID</th>
							<th width="15%">Action</th>
							<th width="20%">Push to warehouse</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(variant, i) in variants">
							<td style="padding-right: 0">
								{{ parent_sku }}_
							</td>
							<td style="padding-left: 0">
								<input
									class="small-margin-right"
									type="text"
									v-model="variant.sku"
									style="width: 80px;"
									placeholder="SKU"
									v-on:keyup.enter="addVariant()"
									:disabled="!!variant.id" />
							</td>
							<td><input class="small-margin-right" type="text" placeholder="EAN" maxlength="13" v-model="variant.ean"
										 v-on:keyup.enter="addVariant()"/></td>

							<td><input class="small-margin-right" type="text" placeholder="STOCK" maxlength="13"
										 v-model="variant.stock_quantity"/></td>
							<td>
								<template v-if="!!variant.id">
									#{{ variant.id }}
								</template>
								<template v-else>
									(New)
								</template>
							</td>
							<td>
                <button v-if="variant.id === undefined" class="small-margin-right danger" v-on:click="deleteVariant(i)">x</button>
                <button v-if="variant.id" class="small-margin-right danger" v-on:click="deleteVariantFromAllSystems(variant)">x</button>
							</td>
              <td>
                <div
                  v-on:click="pushVariantToWarehouse(getId(), variant.id)"
                  class="push-button"
                >
                  <span class="white">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path
                        d="M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"/>
                    </svg>
                  </span>
                </div>
              </td>
						</tr>
					</tbody>
				</table>
				<button v-on:click="addVariant()">+ Add variant</button>

				<br><br>
				<table v-if="images.length > 0" class="table image">
					<thead>
					<tr>
						<th width="40%">Image</th>
						<th>Position</th>
						<th>Action</th>
					</tr>
					</thead>
					<tbody>
						<tr v-for="image in images">
							<td>
								<img v-if="image.src !== null" :src="image.src" alt="">
								<FormFileField v-if="image.src === null" :id="image.fieldId" :url="image.src" @uploadedFile="uploadedFile"></FormFileField>
							</td>
							<td>
								<input type="text" title="Position" v-model="image.position" class="small">
							</td>
							<td>
								<button v-show="saving !== image.id" class="small-margin-right" @click="removeUploader(image)">x</button>
								<i v-if="saving === image.id">Removing</i>
							</td>
						</tr>
					</tbody>
				</table>

				<button v-on:click="addMoreImage()">+ Add product image</button>

			</div>

			<div class="margin-top padding-top border-top">
				<button :disabled="saving" v-on:click="create()">
					<template v-if="editMode">Save</template>
					<template v-else>Create</template>
				</button>
				<template v-if="editMode">
          <span style="margin-left: 10px;">or <a href="#" v-on:click="createAnotherProduct()">create another product</a></span>
        </template>
        <button v-if="editMode" class="danger margin-left" :disabled="saving" v-on:click="deleteProductFromAllSystems()">
          <template>Delete</template>
        </button>
      </div>
		</div>

		<div class="margin-bottom" v-show="active_tab == 'cache'">
			<Loader :soft="true" v-if="inventory_cache_updating" />
			<button @click="updateProductInventoryCache()">Update inventory cache of all valiants</button>
			<Table :columns="inventory_cache_columns" :rows="inventory_cache" />
		</div>

		<div class="margin-bottom" v-show="active_tab == 'events'">
			<EventViewer class="margin-top" :resource="'product:' + id" />
		</div>

		<div class="margin-bottom" v-show="active_tab == 'stock_management'">
			<div class="text-right flex align-items" style="background: #efefef;padding:15px;border:1px solid #ccc">
				<h2>
					<button class="smaller small-margin-right" :class="{light: (variant.id == stock_management_selected_variant_id)}"
							v-for="(variant, i) in variants" @click="setInventoryLogVariantId(variant.id)">{{variant.sku}}
					</button>
				</h2>
				<div class="flex-grow text-right">
					<button v-on:click="getInventoryLogRecords()" class="small-margin-left">Refresh</button>
				</div>
			</div>
			<Loader :soft="true" v-if="inventory_log_updating" />
			<Table :columns="stock_management_columns" :rows="inventory_log" />
		</div>

		<div class="margin-bottom" v-show="active_tab == 'block'">
			<BlockedProducts :product_id="getProductId()" :variants="variants_list"></BlockedProducts>
		</div>
    <div class="margin-bottom" v-show="active_tab == 'ai' && product_id !== null">
			<Ai :product_id="getProductId()" :variants="variants_list"></Ai>
		</div>

    <Modal v-if="show_editInventoryCache" v-on:close="show_editInventoryCache = false">
      <EditInventoryCache :product-id="product_id" :inventory-cache="editInventoryCache" v-on:success="show_editInventoryCache = false;" v-on:closeModal="show_editInventoryCache = false;"/>
    </Modal>
	</div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import FormFileField from '@/components/FormFileField.vue'
import EventViewer from '@/components/EventViewer.vue'
import ProductTags from '@/components/ProductTags.vue'
import ProductAttributes from '@/components/ProductAttribute.vue'
import BlockedProducts from '@/components/products/BlockedProducts'
import EditInventoryCache from './EditInventoryCache.vue'
import Ai from '@/components/products/Ai.vue'

export default {
  components: {
    BlockedProducts,
    FormFileField,
    EventViewer,
    ProductTags,
    ProductAttributes,
    EditInventoryCache,
    Ai
  },
  props: [
    'id'
  ],
  data: () => ({
    loading: false,
    softLoading: false,
    inventory_cache_updating: false,
    inventory_log_updating: false,
    block_tab_activity: false,
    tabs: {
      general: {
        name: 'General'
      },
      cache: {
        name: 'Inventory cache'
      },
      events: {
        name: 'Events'
      },
      stock_management: {
        name: 'Stock Management'
      },
      block: {
        name: 'Block/Unblock'
      },
      ai: {
        name: 'AI Product Description'
      }
    },
    inventory_cache_columns: {
      id: {},
      sku: {},
      size: {},
      size_converted_min: {},
      size_converted_max: {}
    },
    stock_management_columns: {
      sku: {},
      ean_code: {},
      order_id: {},
      qty_before: {},
      qty_change: {},
      qty_after: {},
      reason: {},
      misc: {},
      success_at: {},
      failed_at: {},
      failed_with: {}
    },
    active_tab: 'general',
    title: '',
    product_id: null,
    parent_sku: '',
    price: {},
    sales_price: {},
    price_percentage: {},
    category: '',
    subcategory: '',
    currencies: [],
    categories: [],
    brand: '',
    brands: [],
    product_options: [],
    colorful_id: null,
    patterns_id: null,
    color: '',
    colors: [],
    prints: [],
    print: '',
    styles: [],
    style: '',
    pantSizes: [30, 32, 34],
    pantSize: '',
    countries: [],
    country: '',
    description: '',
    weight: '',
    tariff: '',
    materials: [
      { id: 0, material: {}, percentage: '' }
    ],
    materialList: [],
    tags: [],
    saving: false,
    variants: {},
    exceptions: {},
    images: [],
    imageFields: [],
    inventory_cache_records: [],
    variants_list: [],
    stock_management_selected_variant_id: null,
    inventory_log_records: [],
    wp_url: process.env.VUE_APP_WP_URL,
    show_editInventoryCache: false,
    editInventoryCache: null
  }),
  computed: {
    inventory_cache () {
      return this.inventory_cache_records.map(row => {
        row.menu = [
          {
            name: 'Edit',
            onClick: row => this.showEditInventoryCache(row)
          },
          {
            name: 'Update Inventory Cache',
            onClick: row => this.refreshInventoryCache(row)
          }
        ]

        return row
      })
    },
    hasVariants () {
      return !_.isEmpty(this.variants)
    },
    editMode () {
      return !!this.getId()
    },
    parentCategory () {
      return _.filter(this.categories, function (item) {
        return item.parent === null
      })
    },
    subCategories () {
      if (this.category === '' || this.category === null || this.category === undefined) {
        return []
      }
      const selected = this.category
      return _.filter(this.categories, function (item) {
        return item.parent === selected
      })
    },
    inventory_log () {
      if (this.stock_management_selected_variant_id === null) {
        // this.stock_management_selected_variant_id = Object.keys(this.variants)[0]
        this.setInventoryLogVariantId(Object.keys(this.variants)[0])
      }
      return _.filter(this.inventory_log_records, (log) => {
        return log.variant_id == this.stock_management_selected_variant_id
      })
    }
  },
  methods: {
    setInventoryLogVariantId (variantId) {
      this.stock_management_selected_variant_id = variantId
    },
    getInventoryLogRecords () {
      Vue.$api.get('/inventory/logs/product/' + this.getProductId() + '/list', {}, {
        before: () => this.inventory_log_updating = true,
        always: () => this.inventory_log_updating = false,
        callback: data => {
          this.inventory_log_records = data
        }
      })
    },
    updateProductInventoryCache () {
      Vue.$api.post('/inventory-cache/product/' + this.getProductId() + '/refresh', {}, {
        before: () => this.inventory_cache_updating = true,
        always: () => this.inventory_cache_updating = false,
        callback: data => {
          this.inventory_cache_records = data
        }
      })
    },
    showEditInventoryCache (row) {
      this.editInventoryCache = row
      this.show_editInventoryCache = true
    },
    refreshInventoryCache (row) {
      Vue.$api.post('/inventory-cache/' + row.id + '/refresh', {}, {
        before: () => this.inventory_cache_updating = true,
        always: () => this.inventory_cache_updating = false,
        callback: data => {
          for (var i in this.inventory_cache_records) {
            if (this.inventory_cache_records[i].id == row.id) {
              Vue.set(this.inventory_cache_records, i, data)
              // this.inventory_cache_records[i] = data;
            }
          }
        }
      })
    },
    getId () {
      return this.id
    },
    getProductId () {
      return this.product_id
    },
    formatMaterialForSaving () {
      const materials = []
      _.each(this.materials, (material) => {
        materials.push({
          id: material.material.id,
          name: material.material.name,
          percentage: material.percentage
        })
      })
      return JSON.stringify(materials)
    },
    formatMaterialForView (data) {
      this.materials = []
      if (this.isJson(data)) {
        const materials = JSON.parse(data)
        _.each(materials, (item, index) => {
          this.materials.push({ id: index, material: { id: item.id, name: item.name }, percentage: item.percentage })
        })
      }
    },
    getCategories () {
      const categories = []; const thatCategory = this.category; const thatSubCategory = this.subcategory
      if (this.category) {
        categories.push(_.filter(this.categories, function (item) {
          return item.id === thatCategory
        })[0])
      }
      if (this.subcategory) {
        categories.push(_.filter(this.categories, function (item) {
          return item.id === thatSubCategory
        })[0])
      }

      return categories
    },
    create () {
      if (!this.allValidationPasses()) {
        return
      }
      Vue.api.post('/product', {
        id: this.getId(),
        title: this.title,
        parent_sku: this.parent_sku,
        price: this.price,
        sales_price: this.sales_price,
        categories: this.getCategories(),
        attributes: {
          brand: this.brand,
          color: this.color,
          print: this.print,
          style: this.style,
          pant_size: this.pantSize,
          description: this.description,
          colorful_id: this.colorful_id,
          patterns_id: this.patterns_id
        },
        accounting: {
          weight: this.weight,
          country_of_origin_id: this.country,
          tariff: this.tariff
        },
        material: this.formatMaterialForSaving(),
        variants: this.variants,
        images: this.images,
        tags: this.tags
      }, {
        before: () => this.softLoading = true,
        always: () => this.softLoading = false,
        callback: (data) => {
          if (this.editMode) {
            this.$router.go(0)
          }
          this.$router.push('/product/' + data.data.id)
          window.location.reload();
        }
      })
    },
    allValidationPasses () {
      if (!this.validateTitle()) {
        return false
      }
      if (!this.validateSKU()) {
        return false
      }
      if (!this.validateVariant()) {
        return false
      }
      if (!this.validatePrices()) {
        return false
      }
      if (this.sekPriceLowerThanDdkPrice()) {
        if (!confirm('SEK price is lower than DKK price. Is this intentional?')) {
          return false
        }
        return true
      }
      return true
    },
    isJson (item) {
      item = typeof item !== 'string'
        ? JSON.stringify(item)
        : item

      try {
        item = JSON.parse(item)
      } catch (e) {
        return false
      }

      if (typeof item === 'object' && item !== null) {
        return true
      }

      return false
    },
    validateTitle () {
      if (this.title.length == 0) {
        alert('Product title is required !!')
        return false
      }
      return true
    },
    validateSKU () {
      const sku = this.parent_sku

      if (sku.length == 0) {
        alert('SKU is required !!')
        return false
      }
      if (/\s/.test(sku)) {
        alert('Parent sku should not contain any space')
        return false
      }

      return true
    },
    validateVariant () {
      if (_.isEmpty(this.variants)) {
        alert('There should be at least one variant for this product')
        return false
      }
      let hasSpace = false
      _.each(this.variants, (variant) => {
        if (/\s/.test(variant.sku)) {
          hasSpace = true
        }
      })
      if (hasSpace) {
        alert('Variant size should not contain any space')
        return false
      }

      return true
    },
    validatePrices () {
      const thatPrice = this.price
      const thatSalesPrice = this.sales_price
      let status = true
      _.forEach(this.currencies, function (currency) {
        if (parseFloat(thatPrice[currency.id]) < parseFloat(thatSalesPrice[currency.id])) {
          alert(currency.iso4217_code + ' regular price must not be lower than sale price')
          status = false
        }
      })
      return status
    },
    sekPriceLowerThanDdkPrice () {
      if (parseFloat(this.price[2]) < parseFloat(this.price[1])) {
        return true
      }

      if (parseFloat(this.sales_price[2]) < parseFloat(this.sales_price[1])) {
        return true
      }

      return false
    },
    deleteVariant (i) {
      Vue.delete(this.variants, i)
    },
    deleteVariantFromAllSystems (i) {
      if (!confirm("Warning !!!!! You are about to delete this variant from all systems. Are you sure you want to continue?")) {
        return;
      }
      Vue.api.delete('product/' + this.id + '?variant_id=' + i.id, {
        variant_id: i.id
      }, {
        before: () => this.softLoading = true,
        always: () => this.softLoading = false,
        callback: () => {
          this.softLoading = false
          window.location.reload();
        }
      })
    },
    deleteProductFromAllSystems () {
      if (!confirm("Warning !!!!! You are about to delete this product with all it's variants from all systems. " +
        "Are you sure you want to continue?"
      )) {
        return;
      }
      Vue.api.delete('product/' + this.id, {}, {
        before: () => this.softLoading = true,
        always: () => this.softLoading = false,
        callback: () => {
          this.softLoading = false
          alert('Deleted')
          this.$router.push('/products/create');
          window.location.reload();
        }
      })
    },
    createAnotherProduct() {
      this.$router.push('/products/create');
      window.location.reload();
    },
    addVariant () {
      var key = 0
      for (var i in this.variants) {
        if (i >= key) {
          key = Number(i) + 1
        }
      }
      Vue.set(this.variants, key, {
        sku: '',
        ean: ''
      })
    },
    addMaterial () {
      var key = 0
      for (var i in this.materials) {
        if (i >= key) {
          key = Number(i) + 1
        }
      }
      Vue.set(this.materials, key, {
        id: key,
        material: this.materials[0]
      })
    },
    checkForPercentage (material) {
      if (material.percentage > 100) {
        material.percentage = 100
        alert('Material percentage cannot be greater than 100')
      }
    },
    removeMaterial (material) {
      this.materials = _.filter(this.materials, function (item) {
        return item.id !== material.id
      })
    },
    pushProductToWarehouse(productId) {
      if (!confirm("Are you sure you want to push all the variants of the product to warehouse?")) {
        return;
      }
      Vue.api.post('/v2/warehouse/product/' + productId + '/push', {}, {
        before: () => this.softLoading = true,
        always: () => this.softLoading = false,
        callback: () => {
          this.softLoading = false
        }
      });
    },
    pushVariantToWarehouse(productId, variantId) {
      if (!confirm("Are you sure you want to push the variant to warehouse?")) {
        return;
      }
      Vue.api.post('/v2/warehouse/product/' + productId + '/push', {
        variant_ids: [variantId]
      }, {
        before: () => this.softLoading = true,
        always: () => this.softLoading = false,
        callback: () => {
          this.softLoading = false
        }
      });
    },
    loaded (data) {
      for (const i in data.variants) {
        if (data.parent_sku) {
          data.variants[i].id = data.variants[i].ID
          let sku = data.variants[i].sku.replace(data.parent_sku + '_', '')
          if (data.parent_sku + '_' + sku !== data.variants[i].sku) {
						  alert('Unwanted change of parent SKU is identified !!!')
            sku = ''
          }
          data.variants[i].sku = sku
        }
      }
      this.title = data.post_title
      this.product_id = data.product_id
      this.parent_sku = data.parent_sku
      this.variants = data.variants
      this.variants_list = _.clone(data.variants)
      this.category = data.category
      this.subcategory = data.subcategory
      this.color = data.color
      this.brand = data.brand
      this.print = data.print
      this.colorful_id = data.colorful_id
      this.patterns_id = data.patterns_id
      this.style = data.style
      this.pantSize = data.pant_size
      this.description = data.description
      this.weight = data.weight
      this.tariff = data.tariff
      this.country = data.accounting_country_id
      this.material = this.formatMaterialForView(data.materialRaw)
      this.exceptions = data.exceptions
      this.inventory_cache_records = data.inventory_cache
      this.images = this.formatResponseForImages(data)
      this.formatResponseForCurrencies(data)
      this.getInventoryLogRecords()
    },
    uploadedFile (data) {
      const index = _.findIndex(this.images, function (image) {
        return image.fieldId === data.fieldId
      })
      this.images[index].fieldId = data.fieldId
      this.images[index].id = data.id
      this.images[index].src = data.url
    },
    addMoreImage () {
      let maxFieldId
      if (this.images.length === 0) {
        maxFieldId = 1
      } else {
        maxFieldId = _.maxBy(this.images, 'fieldId')
        maxFieldId = maxFieldId.fieldId + 1
      }
      this.images.push({ fieldId: maxFieldId, id: null, src: null, position: maxFieldId })
    },
    removeUploader (image) {
      if (image.id === null || image.id === undefined) {
        return this.removeImage(image)
      }
      this.deleteImageFromServer(image)
    },
    deleteImageFromServer (image) {
      Vue.api.delete('/image/' + image.id, {}, {
        before: () => this.saving = image.id,
        always: () => this.saving = false,
        callback: (response) => {
          this.removeImage(image)
        }
      })
    },
    removeImage (image) {
      this.images = _.filter(this.images, function (item) {
        return item.fieldId !== image.fieldId
      })
    },
    formatResponseForImages (data) {
      if (undefined === data.images || data.images.length === 0) {
        return []
      }
      const images = []
      let count = 0
      _.forEach(data.images, function (image) {
        count++
        images.push({ fieldId: count, id: image.image_id, src: image.path, position: image.position })
      })

      return images
    },
    formatResponseForCurrencies (data) {
      if (undefined === data.currencyPrices ||	data.currencyPrices.length === 0) {
        return []
      }
      const currencyPrices = data.currencyPrices
      for (const price in currencyPrices) {
        const currencyPrice = currencyPrices[price]
        Vue.set(
          this.price,
          currencyPrice.currency_id,
          currencyPrice.regular_price
        )
        Vue.set(
          this.sales_price,
          currencyPrice.currency_id,
          currencyPrice.sales_price === null ? currencyPrice.regular_price : currencyPrice.sales_price.toFixed(2))
        Vue.set(
          this.price_percentage,
          currencyPrice.currency_id,
          currencyPrice.sales_price === null
            ? 0
            : Math.round(100 * (1 - (currencyPrice.sales_price / currencyPrice.regular_price)))
        )
      }
    },
    updateSalesPrice (currencyId) {
      if (this.price[currencyId] !== undefined) {
        if (this.price_percentage[currencyId] === undefined) {
          Vue.set(this.price_percentage, currencyId, 0)
        }
        let salesPrice = this.price[currencyId] * (1 - (this.price_percentage[currencyId] / 100))
        if (salesPrice === Math.round(salesPrice)) {
          salesPrice = Math.round(salesPrice)
        } else {
          salesPrice = salesPrice.toFixed(2)
        }
        Vue.set(this.sales_price, currencyId, salesPrice)
      }
    },
    updateSalesPercentage (currencyId) {
      if (currencyId === 1) {
        for (const percentage in this.price_percentage) {
          if (percentage !== 1) {
            Vue.set(this.price_percentage, percentage, this.price_percentage[1])
            this.updateSalesPrice(percentage)
          }
        }
      }
      this.updateSalesPrice(currencyId)
    },
    tagSelected (tags) {
      this.tags = tags
    }
  },
  created () {
    Vue.api.get('/currency', {}, {
      callback: data => {
        this.currencies = data
        for (const index in this.currencies) {
          this.price_percentage[this.currencies[index].id] = 0
        }
      }
    })
    Vue.api.get('/category', {}, {
      callback: data => {
        this.categories = data
      }
    })
    Vue.api.get('/brand?exclude_hidden=true', {}, {
      callback: data => {
        this.brands = data
      }
    })
    Vue.api.get('/color', {}, {
      callback: data => {
        this.colors = data
      }
    })
    Vue.api.get('/print', {}, {
      callback: data => {
        this.prints = data
      }
    })
    Vue.api.get('/product-options', {}, {
      callback: data => {
        this.product_options = data
      }
    })
    Vue.api.get('/style', {}, {
      callback: data => {
        this.styles = data
      }
    })
    Vue.api.get('/accounting-country', {}, {
      callback: data => {
        this.countries = data
      }
    })
    Vue.api.get('/material', {}, {
      callback: data => {
        _.each(data, (item) => {
          this.materialList.push({ id: item.id, name: item.name })
        })
        _.sortBy(this.materialList, [(m) => { return m.name }])
      }
    })
    if (this.getId()) {
      Vue.api.get('/product/' + this.getId() + '/editable', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        error: () => {
          this.loading = false
          alert('Product not found')
          this.$router.push('/products/create')
          window.location.reload();
        },
        callback: data => this.loaded(data)
      })
    }
  }
}
</script>

<style scoped>
	.label {
		width: 130px;
	}
	select {
		min-width: 130px;
	}
	.image img {
		width: 150px;
	}
	.price-wrapper {
		display: flex;
	}
	.price-wrapper .sales-price .label{
		width: 105px;
	}
	.price {
		margin-right: 20px;
	}
	table {
		border-top: 0;
		margin-bottom: 10px;
	}
	table tbody tr{
		border-bottom: 1px solid #ccc;
	}
	table th, table td{
		text-align: left;
		padding-left: 0;
	}
	.percentage {
		width: 20px;
	}
	.price .percentage {
		padding: 2px;
		width: 15px;
		cursor: pointer;
		border: 1px solid #cccccc;
	}
	.delete-material {
		padding: 3px 5px;
		margin-bottom: 5px;
		margin-left: 5px;
	}
  .push-button {
    cursor: pointer;
    width: 30px;
    padding: 5px;
  }
  .push-button:hover {
    background-color: #CCCCCC;
  }
</style>
